module.exports = __webpack_public_path__ + "img/Elisa.c3034406.jpeg";